<template>
  <div class="index">
    <div class="navBar">
      <div
        class="navItem"
        v-for="(item, index) in navBarList"
        :key="index"
        :class="{ selected: selectedIndex === index }"
        @click="openPage(item, index)"
        v-show="item.isShow"
      >
        <img :src="item.img" style="width: 24px; margin-right: 10px" alt="" />
        <span>{{ item.text }}</span>
      </div>
    </div>
    <div class="compon">
      <div style="width: 80%" class="childCon">
        <component :is="currentComponent" @toComponent="changeNav"></component>
      </div>
      <div style="width: 20%"><info-bar /></div>
    </div>
  </div>
</template>
<script>
import accountInfo from "./components/accountInfo.vue";
import editPassword from "./components/editPassword.vue";
import securityCenter from "./components/securityCenter.vue";
import otherAccount from "./components/otherAccount.vue";
import watchAccount from "./components/watchAccount.vue";
import accountBinding from "./components/accountBinding.vue";
import passwordQuestion from "./components/passwordQuestion.vue";
import loginLog from "./components/loginLog.vue";
import infoBar from "./components/infoBar.vue";
// import Vue from "vue";
export default {
  name: "personalCenter",
  components: {
    accountInfo,
    editPassword,
    securityCenter,
    otherAccount,
    watchAccount,
    accountBinding,
    passwordQuestion,
    loginLog,
    infoBar,
  },
  data() {
    return {
      selectedIndex: 0,
      // navBarList: [],
      currentComponent: "accountInfo",
      isShow: "",
    };
  },
  mounted() {
    // this.$store.commit("page/setTitle", this.$t("menubar.profile"));
    console.log("personalCenter mounted");
  },
  computed: {
    navBarList() {
      return [
        {
          text: this.$t("profile.account"),
          img: require("@/assets/img/personal/zhxx.png"),
          component: "accountInfo",
          isShow: true,
        },
        {
          text: this.$t("profile.changePassword"),
          img: require("@/assets/img/personal/xgmm.png"),
          component: "editPassword",
          isShow: true,
        },
        {
          text: this.$t("profile.myPhone"),
          img: require("@/assets/img/personal/aqzx.png"),
          component: "securityCenter",
          isShow: this.isShow.includes("phone"),
        },
        {
          text: this.$t("profile.bindEmail"),
          img: require("@/assets/img/personal/dsfzh.png"),
          component: "otherAccount",
          isShow: this.isShow.includes("email"),
        },
        {
          text: this.$t("profile.monitor"),
          img: require("@/assets/img/personal/jkzh.png"),
          component: "watchAccount",
          isShow: true,
        },
        {
          text: this.$t("profile.bind"),
          img: require("@/assets/img/personal/ejmm.png"),
          component: "accountBinding",
          isShow: true,
        },
        {
          text: this.$t("profile.securitySetting"),
          img: require("@/assets/img/personal/mbsz.png"),
          component: "passwordQuestion",
          isShow: true,
        },
        {
          text: this.$t("profile.loginLogs"),
          img: require("@/assets/img/personal/dlrz.png"),
          component: "loginLog",
          isShow: true,
        },
      ];
    },
  },
  watch: {
    selectedIndex(newVal, oldVal) {
      // this.currentComponent = this.navBarList[newVal]?.component;
      console.log("selectedIndex changed:", newVal, oldVal);
    },
  },
  created() {
    if (localStorage.getItem("allConfig")) {
      let allData = [...JSON.parse(localStorage.getItem("allConfig"))];
      for (let i = 0; i <= allData.length; i++) {
        if (allData[i]?.key == "sys.second.validate.way") {
          this.isShow = allData[i]?.value;
        }
      }
    }
  },
  methods: {
    changeNav(index, con) {
      if (index !== undefined && con !== undefined) {
        this.selectedIndex = index;
        this.currentComponent = con;
      }
      if (index !== undefined && !con) {
        this.selectedIndex = index;
        this.currentComponent = this.navBarList[index]?.component;
      }
      if (index === undefined && con) {
        this.currentComponent = con;
        this.selectedIndex = this.navBarList.findIndex(
          (item) => item.component === con
        );
      }
    },
    openPage(item, index) {
      this.currentComponent = item.component;
      this.selectedIndex = index;
      this.$store.dispatch("page/openSubPage", {
        parentName: this.constructor.options.name,
        title: item.text,
        currentComponent: item.component,
        selectedIndex: index,
        props: {
          category: "all",
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.index {
  display: flex;
  // align-items: flex-start;
  height: 100%;
  .navBar {
    background: #ffffff;
    border-radius: 8px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    width: 17%;
    margin-right: 25px;
    // height: 100%;
    .navItem {
      padding: 12px 15px;
      background: #f5f7fb;
      font-size: 14px;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      cursor: pointer;
    }
    .navItem:hover {
      background: #6293ff;
      color: white;
    }
    .navItem.selected {
      background: #6293ff;
      color: white;
    }
  }
  .compon {
    width: 80%;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    height: 100%;
    // margin-top: 20px;
    margin-right: 20px;
    .childCon {
      overflow-y: auto;
      scrollbar-width: none; /* Firefox 专用：隐藏滚动条 */
      -ms-overflow-style: none; /* IE 和 Edge 专用：隐藏滚动条 */
    }
    .childCon::-webkit-scrollbar {
      display: none; /* 隐藏滚动条 */
    }
  }
}
</style>
